// import React, { useEffect, useState } from "react";
// import { NextUIProvider } from "@nextui-org/react";
// import { useLocation } from "react-router-dom";
// import Header from "./components/ui/Header/Header.tsx";
// import MenuMobile from "./components/ui/Header/MenuMobile.tsx";
// import Footer from "./components/ui/Footer/Footer.tsx";
// import WhatsApp from "./components/ui/Whatsapp/WhatsApp.tsx";
// import { Outlet } from "react-router-dom";
// import "./index.css";
// import Cookies from "./components/ui/Cookies/Cookies.tsx";
// import AutoLogout from "./components/AutoLogout.tsx";

// const App = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const location = useLocation();

//   const toggle = () => {
//     setIsOpen(!isOpen);
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [location]);

//   const isDashboard = location.pathname.startsWith("/dashboard");
//   const isLanding = location.pathname.startsWith("/landing");

//   return (
//     <React.StrictMode>
//       <NextUIProvider>
//         <div className="flex flex-col min-h-screen mx-auto">
//           {isDashboard && <AutoLogout />}

//           {/* Só renderiza se não for Dashboard nem Landing */}
//           {!isDashboard && !isLanding && <Header />}
//           {!isDashboard && !isLanding && <MenuMobile toggle={toggle} />}

//           <main className="flex-grow">
//             <Outlet />
//           </main>

//           {!isDashboard && !isLanding && <Footer />}
//           {!isDashboard && !isLanding && <WhatsApp />}
//           {!isDashboard && !isLanding && <Cookies />}
//         </div>
//       </NextUIProvider>
//     </React.StrictMode>
//   );
// };

// export default App;

import React, { useEffect, useState } from "react";
import { NextUIProvider } from "@nextui-org/react";
import { useLocation } from "react-router-dom";
import Header from "./components/ui/Header/Header.tsx";
import MenuMobile from "./components/ui/Header/MenuMobile.tsx";
import Footer from "./components/ui/Footer/Footer.tsx";
import WhatsApp from "./components/ui/Whatsapp/WhatsApp.tsx";
import { Outlet } from "react-router-dom";
import "./index.css";
import Cookies from "./components/ui/Cookies/Cookies.tsx";
import AutoLogout from "./components/AutoLogout.tsx";

const App = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const isDashboard = location.pathname.startsWith("/dashboard");
  // const isLanding = location.pathname.startsWith("/landing");
  const isLinks = location.pathname.startsWith("/links");

  const hideLayout = isDashboard || isLinks;
  // || isLanding

  return (
    <React.StrictMode>
      <NextUIProvider>
        <div className="mx-auto flex min-h-screen flex-col overflow-x-hidden">
          {isDashboard && <AutoLogout />}

          {!hideLayout && <Header />}
          {!hideLayout && <MenuMobile toggle={toggle} />}

          <main className="flex-grow">
            <Outlet />
          </main>

          {!hideLayout && <Footer />}
          {!hideLayout && <WhatsApp />}
          {!hideLayout && <Cookies />}
        </div>
      </NextUIProvider>
    </React.StrictMode>
  );
};

export default App;
